import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimelineRegion = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 15.5C5 15.2239 4.77614 15 4.5 15H3.5C3.22386 15 3 15.2239 3 15.5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H8.5C8.77614 21 9 20.7761 9 20.5V19.5C9 19.2239 8.77614 19 8.5 19H5.5C5.22386 19 5 18.7761 5 18.5V15.5ZM8.5 5C8.77614 5 9 4.77614 9 4.5V3.5C9 3.22386 8.77614 3 8.5 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V8.5C3 8.77614 3.22386 9 3.5 9H4.5C4.77614 9 5 8.77614 5 8.5V5.5C5 5.22386 5.22386 5 5.5 5H8.5ZM19 8.5C19 8.77614 19.2239 9 19.5 9H20.5C20.7761 9 21 8.77614 21 8.5V5C21 3.89 20.1 3 19 3H15.5C15.2239 3 15 3.22386 15 3.5V4.5C15 4.77614 15.2239 5 15.5 5H18.5C18.7761 5 19 5.22386 19 5.5V8.5ZM15.5 19C15.2239 19 15 19.2239 15 19.5V20.5C15 20.7761 15.2239 21 15.5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V15.5C21 15.2239 20.7761 15 20.5 15H19.5C19.2239 15 19 15.2239 19 15.5V18.5C19 18.7761 18.7761 19 18.5 19H15.5ZM14.6875 12.5818C15.1042 12.3232 15.1042 11.6768 14.6875 11.4182L10.9375 9.09101C10.5208 8.83243 10 9.15565 10 9.67281V14.3272C10 14.8443 10.5208 15.1676 10.9375 14.909L14.6875 12.5818Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgTimelineRegion);
export { ForwardRef as ReactComponent };
